/**
 * Per-platform stats for Anim-8 / Song content carousel slides.
 * Keys match contentMedia item ids in caseStudies.js.
 */
export const anim8ContentAboutMedia = [
  {
    id: 'anim8-song-coffee-monster-fight',
    label: 'Coffee Monster Fight',
    socialStats: {
      tiktok: {
        views: 137,
        likes: 10,
        comments: 2,
        saves: 3,
      },
      instagram: {
        views: 4549,
        likes: 315,
        comments: 102,
      },
    },
  },
  {
    id: 'anim8-song-coffee-backrooms',
    label: 'Coffee Backrooms',
    socialStats: {
      tiktok: {
        views: 2201,
        likes: 176,
        comments: 13,
        saves: 23,
      },
      instagram: {
        views: 5072,
        likes: 259,
        comments: 51,
      },
    },
  },
  {
    id: 'anim8-song-the-brew',
    label: 'The Brew',
    socialStats: {
      tiktok: {
        views: 25500,
        likes: 1828,
        comments: 67,
        saves: 508,
      },
      instagram: {
        views: 73800,
        likes: 7298,
        comments: 1561,
      },
    },
  },
  {
    id: 'anim8-song-skate-night',
    label: 'Song Skate Night/Day',
    socialStats: {
      tiktok: {
        views: 326,
        likes: 12,
        comments: 3,
        saves: 4,
      },
      instagram: {
        views: 33900,
        likes: 434,
        comments: 38,
      },
    },
  },
  {
    id: 'anim8-song-finding-kiiboh',
    label: 'Finding Kiiboh',
    socialStats: {
      tiktok: {
        views: 194,
        likes: 15,
        comments: 2,
        saves: 2,
      },
      instagram: {
        views: 165000,
        likes: 5916,
        comments: 56,
      },
    },
  },
  {
    id: 'anim8-song-caffeine-overload',
    label: 'Song Caffeine Overload',
    socialStats: {
      tiktok: {
        views: 1454,
        likes: 175,
        comments: 7,
        shares: 28,
      },
      instagram: {
        views: 72500,
        likes: 2665,
        comments: 39,
      },
    },
  },
]
